// Today's date as YYYY-MM-DD in the *user's local* timezone.
//
// `new Date().toISOString().slice(0, 10)` returns the UTC date, which rolls over
// to "tomorrow" for users west of UTC after ~16:00 local. The commission engine
// keys structures off effective_from (a plain date), so a UTC-derived default
// can silently mis-date a structure or FX rate. Build the date from local parts.
export function todayLocalDate(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
